import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { get_dashboard, user_profile } from "../../actions/auth/Action";
import { get_addresses, get_cart, get_origins } from "../../actions/orders";
import file from "../../assets/file.svg";
import { NavWrap } from "../ShopForTyres";
import PendingActions from "./PendingActions";
import UpcomingPayments from "./UpcomingPayments";
import "./dashboard.css";

const OverviewTab = ({ isShipment }) => {
  const dashboard = useSelector(
    (state) => state?.auth?.dashboard?.data?.dash_borad?.[0]
  );
  return (
    <div className="overview-tab">
      <div className="d-flex">
        <div className="activity">
          <span>
            <img src={file} width={30} alt="file" />
          </span>
          <span className="title">
            {isShipment ? "Shipment" : "Orders"} Activity
          </span>
        </div>
        {isShipment ? (
          <div className="contents w70">
            <div>
              <label>Planned</label>
              <span>
                {parseInt(dashboard?.["ShipStatus0"] || 0) +
                  parseInt(dashboard?.["ShipStatus1"] || 0) || "-"}
              </span>
            </div>
            <div>
              <label>In-Transit</label>
              <span>
                {parseInt(dashboard?.["ShipStatus6"] || 0) +
                  parseInt(dashboard?.["ShipStatus2"] || 0) +
                  parseInt(dashboard?.["ShipStatus3"] || 0) +
                  parseInt(dashboard?.["ShipStatus4"] || 0) || "-"}
              </span>
            </div>
            <div>
              <label>Completed</label>
              <span>
                {parseInt(dashboard?.["ShipStatus5"] || 0) +
                  parseInt(dashboard?.["CompletedDelivery"] || 0) +
                  parseInt(dashboard?.["ShipStatus7"] || 0) || "-"}
              </span>
            </div>
          </div>
        ) : (
          <div className="contents w80">
            <div>
              <label>Order to be confirmed</label>
              <span>
                {dashboard?.["OpenQuotation"]
                  ? dashboard?.["OpenQuotation"]
                  : "-"}
              </span>
            </div>
            <div>
              <label>Order Confirmed</label>
              <span>
                {dashboard?.["CompletedQuotation"]
                  ? dashboard?.["CompletedQuotation"]
                  : "-"}
              </span>
            </div>
            <div>
              <label>Order Completed</label>
              <span>
                {dashboard?.["CompletedSales"]
                  ? dashboard?.["CompletedSales"]
                  : "-"}
              </span>
            </div>
            {/* <div>
              <label>Cancelled</label>
              <span>-</span>
            </div> */}
          </div>
        )}
      </div>
    </div>
  );
};

const Dashboard = () => {
  const dispatch = useDispatch();
  const addresses = useSelector((state) => state?.orders?.addresses?.data);
  const profile = useSelector((state) => state?.auth?.profile?.data?.customer);
  const history = useHistory();
  const addr = profile?.shipping_addresses?.[0];

  useEffect(() => {
    let obj = {
      email: localStorage.getItem("email"),
    };
    dispatch(user_profile(obj));
    dispatch(get_origins(obj));
    dispatch(get_addresses(obj));
    dispatch(get_dashboard(obj));
    if (localStorage.getItem("cardId")) dispatch(get_cart(obj));
    // dispatch(price_worker(obj))
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    localStorage.setItem("shipping_addresses", JSON.stringify(addresses));
  }, [addresses]);
  return (
    <NavWrap>
      <div className="cart dashboard">
        <div className="head-sec">
          <div>
            <label>Hello, {addr?.name}</label>
          </div>
          <div>{/* <label>Last 30 Days</label> */}</div>
        </div>
        <div className="ot1">
          <OverviewTab />
        </div>
        <div className="ot2">
          <OverviewTab isShipment={true} />
        </div>
        <div className="dash-details">
          <div className="dashImg">
            <div>
              <h3>ORDER YOUR TYRES RIGHT FROM THE DASHBOARD</h3>
              <p>View our wide range of brands covering multiple segments</p>
            </div>
            <div className="btns">
              <button
                className="primary-btn"
                onClick={() => {
                  history.push("/shop-for-tyres");
                }}
              >
                Place an Order
              </button>
              <button
                className="white-btn"
                onClick={() => {
                  history.push("/track-shipments");
                }}
              >
                Track Shipments
              </button>
            </div>
          </div>
          <div className="details">
            <div className="box">
              <div>
                <span>Email</span>
                <span>{localStorage.getItem("c_email")}</span>
              </div>

              {Array.isArray(addresses) &&
                [...new Map(addresses.map(item => [item.kunn2, item])).values()]?.slice(0, 3)?.map((address, i) => (
                  <div>
                    <span>Shipping Address {i + 1}</span>
                    <span>
                      {address?.name}
                      <br />
                      {address?.address1 && (
                        <>
                          {address?.address1},
                          <br />
                        </>
                      )}
                      {address?.address2 && (
                        <>
                          {address?.address2},
                          <br />
                        </>
                      )}
                      {address?.city && (
                        <>
                          {address?.city},
                          <br />
                        </>
                      )}
                      {address?.state} {address?.zip}
                    </span>
                  </div>
                ))}
              <span
                className="link cursor"
                onClick={() => {
                  history.push("/profile");
                }}
              >
                View My Profile
              </span>
            </div>
            <div className="box"></div>
          </div>
        </div>
        <PendingActions />
        <UpcomingPayments />
      </div>
    </NavWrap>
  );
};

export default Dashboard;
